<template>
    <ui-feed-card class="success">
        <template #header>
            {{ data.message }}
        </template>

        <ui-tag-icon icon="fal fa-user-circle" :icon-size="18" :text-size="13" :has-hover="true" :text="data.customer.name" :url="dealUrl" :border="0" />

        <ui-tag-indicator color="#4BB478" :text-size="10" :text="String(data.deal_id)" radius="4" />

        <template #footer >
            <ui-popover-user :img="getImgCDN(data.user.cover)" :name="data.user.first_name" disabled />
        </template>

        <template #datetime>{{ createdComputed }}</template>
    </ui-feed-card>
</template>

<script>
    import { uiFeedCard, uiTagIcon } from '@/components/ui'
    import { uiTagIndicator } from '@/components/ui/tags'
    import uiPopoverUser from '@/components/ui-facilita/popovers/popover-user'

    import helpers from '@/mixins/helpers'

    const moment = require('moment')
    require('moment/locale/pt-br')

    export default {
        name: 'queues-history-feed-card',

        components: {
            uiFeedCard,
            uiTagIndicator,
            uiPopoverUser,
            uiTagIcon,
        },

        mixins: [helpers],

        props: {
            data: {
                type: Object,
                required: true,
                default: function () {
                    return {}
                },
            },
        },

        data() {
            return {}
        },

        computed: {
            dealUrl(){
                return this.oldPanelLink(`vendas/negocios/${this.data.deal_id}`)
            },

            createdComputed(){
                return moment(this.data.created_at).format('lll')
            },

            hasHeader() {
                return this.$slots.header ? true : false
            },

            hasFooter() {
                return this.$slots.footer ? true : false
            },

            hasDatetime() {
                return this.$slots.datetime ? true : false
            },
        },

        methods: {
            sendToPerfil(){
                this.oldPanelLinkButton(`perfil/${this.data.user_id}`)
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>
